import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
} from "@/utils/library/languages";

export function isBlogPath(pathname: string): boolean {
  const segments = pathname.split("/").filter(Boolean);
  return segments.includes("blog");
}

export function getLangFromPath(pathname: string): string {
  const firstSegment = pathname.split("/").find(Boolean) ?? "";
  if ((SUPPORTED_LANGUAGES as readonly string[]).includes(firstSegment)) {
    return firstSegment;
  }
  return DEFAULT_LANGUAGE;
}
